/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Policy_Floor_DescriptionInputs */



/**
* | output |
* | --- |
* | "Agents cannot be set to act more independently than this." |
*
* @param {Agent_Policy_Floor_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_floor_description = /** @type {((inputs?: Agent_Policy_Floor_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_Floor_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Agenten können nicht selbstständiger eingestellt werden.")
	return /** @type {LocalizedString} */ ("Agents cannot be set to act more independently than this.")
});